/* ---------------------------------------------------------------------------
   Quick view: the price lives on the button

   Mirrors what product-add-to-cart.liquid does on the product page — "Add to
   cart  9,00 €" instead of a bare label with the price floating somewhere above
   it. The shopper reads what it costs on the control they are about to press.

   Why this is a page asset instead of a script inside the quick view
   ------------------------------------------------------------------
   templates/product.quick_view.liquid is fetched and injected with innerHTML,
   and markup inserted that way never executes its own <script> tags. A copy of
   this logic living inside the modal would be inert. So it loads once with the
   page and watches for the modal instead.

   Why it has to keep watching
   ---------------------------
   The theme rewrites the whole button on every variant change (main.build.js,
   updateButtons -> formButton.innerHTML = ...), using the plain translation. A
   price written once would survive until the shopper picked a different option
   and then silently vanish. The observer puts it back.

   The loop guard is the same one the product page learned the hard way: compare
   textContent, never innerHTML, and build the label from DOM nodes. A product
   titled "Matcha & lemon" comes back from the serialiser as "Matcha &amp;
   lemon", so an innerHTML comparison never matches, the label is rewritten on
   every pass, each rewrite retriggers the observer, and the tab locks up.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MODAL = '.js-quick-view';
  var BUTTON = '.js-quick-submit-button';
  var PRICE_HOST = '.js-quick-view-price';

  function currentPrice(root) {
    var el =
      root.querySelector(PRICE_HOST + ' [data-product-price]') ||
      root.querySelector(PRICE_HOST + ' .price-item--sale') ||
      root.querySelector(PRICE_HOST + ' .price-item');

    return el && el.textContent ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function apply(root) {
    var button = root.querySelector(BUTTON);

    // A disabled button is sold out or unavailable. "Sold out  9,00 €" reads as
    // an offer, which it is not, so those states keep their plain wording.
    if (!button || button.disabled) {
      root.removeAttribute('data-cta-price');
      return;
    }

    var label = button.querySelector('span[data-text]') || button.querySelector('span[data-loading]');
    if (!label) return;

    var price = currentPrice(root);
    if (!price) {
      root.removeAttribute('data-cta-price');
      return;
    }

    var target = label.querySelector('span') || label;
    var lead = target.textContent.replace(/\s+/g, ' ').replace(price, '').trim();
    if (!lead) return;

    var wanted = lead + ' ' + price;
    var current = target.textContent.replace(/\s+/g, ' ').trim();

    if (current === wanted && target.querySelector('.add-to-cart__price')) {
      root.setAttribute('data-cta-price', 'on');
      return;
    }

    var priceEl = document.createElement('span');
    priceEl.className = 'add-to-cart__price';
    priceEl.textContent = price;

    target.textContent = lead + ' ';
    target.appendChild(priceEl);

    if (label.hasAttribute('data-text')) {
      label.setAttribute('data-text', wanted);
    }

    // Only now is the standalone price safe to hide: the CSS keys off this
    // attribute, so if anything above bails out the ordinary price stays put
    // and the modal never shows a product with no price at all.
    root.setAttribute('data-cta-price', 'on');
  }

  var watched = new WeakSet();

  function watch(root) {
    if (watched.has(root)) return;
    watched.add(root);

    apply(root);

    new MutationObserver(function () {
      apply(root);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function scan() {
    var roots = document.querySelectorAll(MODAL);
    for (var i = 0; i < roots.length; i++) watch(roots[i]);
  }

  function init() {
    scan();

    // The modal is added to the page the first time a card's quick view is
    // opened, so the document has to be watched for it arriving at all.
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
